import {
  FETCH_SKILL_RECOMMENDATION_SUCCESS,
} from './actions';

import { Map } from 'immutable';
import SkillRecommendation from './model';

export default function skillRecommendations(state = new Map(), action) {
  switch (action.type) {
    case FETCH_SKILL_RECOMMENDATION_SUCCESS:
      return state.set(`${action.groupId}`, onSuccess(action.payload));
    default:
      return state;
  }
}

function onSuccess(payload) {
  return payload.reduce((result, skillRecommendation) =>
    result.set(`${skillRecommendation.skillId}`, SkillRecommendation.create(skillRecommendation))
    , new Map());
}



// WEBPACK FOOTER //
// ./data/SkillRecommendation/reducer.js